import EventIcon from "@mui/icons-material/Event";
import ScheduleIcon from "@mui/icons-material/Schedule";
import PeopleIcon from "@mui/icons-material/People";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import EventRepeatIcon from "@mui/icons-material/EventRepeat";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

const cards = [
  { key: "appointments", label: "Scheduled", icon: EventIcon, bg: "bg-amber-100", text: "text-amber-700", iconBg: "bg-amber-500" },
  { key: "pending", label: "Upcoming", icon: ScheduleIcon, bg: "bg-orange-100", text: "text-orange-700", iconBg: "bg-orange-500" },
  { key: "inqueue", label: "In Queue", icon: PeopleIcon, bg: "bg-sky-100", text: "text-sky-700", iconBg: "bg-sky-500" },
  { key: "ongoing", label: "Ongoing", icon: PlayCircleIcon, bg: "bg-lime-100", text: "text-lime-700", iconBg: "bg-lime-500" },
  { key: "completed", label: "Completed", icon: CheckCircleIcon, bg: "bg-emerald-100", text: "text-emerald-700", iconBg: "bg-emerald-500" },
  { key: "cancelled", label: "Cancelled", icon: CancelIcon, bg: "bg-red-100", text: "text-red-700", iconBg: "bg-red-500" },
  { key: "reschudle", label: "Rescheduled", icon: EventRepeatIcon, bg: "bg-cyan-100", text: "text-cyan-700", iconBg: "bg-cyan-500" },
  { key: "noshow", label: "No Show", icon: VisibilityOffIcon, bg: "bg-slate-100", text: "text-slate-700", iconBg: "bg-slate-500" },
];

function AppointmentCounts({ count }: any) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-2 sm:gap-3">
      {cards.map(({ key, label, icon: Icon, bg, text, iconBg }) => (
        <div key={key} className={`${bg} rounded-lg sm:rounded-xl p-2 sm:p-4 flex flex-row sm:flex-col items-center justify-center`}>
          <div className="hidden sm:flex w-10 h-10 items-center justify-center sm:mb-2">
            <div className={`w-10 h-10 ${iconBg} rounded-lg flex items-center justify-center`}>
              <Icon className="text-white" sx={{ fontSize: 20 }} />
            </div>
          </div>
          <div className="flex flex-row sm:flex-col items-center justify-center gap-1.5 sm:gap-0">
            <h3 className={`text-sm sm:text-2xl font-bold ${text} leading-tight`}>{count?.[key] ?? 0}</h3>
            <span className={`text-[8px] sm:text-xs font-medium ${text} uppercase tracking-wide text-center leading-tight`}>{label}</span>
          </div>
        </div>
      ))}
    </div>
  );
}

export default AppointmentCounts;

